import React from 'react';
import { Paper, makeStyles, colors } from '@material-ui/core';

import CreateAccountSteps from 'pages/create_account/steps/CreateAccountSteps';

const useStyles = makeStyles({
  root: {
    padding: 16,
    marginTop: 64,
  },
  title: {
    color: colors.red[400],
  },
});

const CreateAccountCard = ({
  step,
  backRouter,
  nextRouter,
  form,
  setForm,
  formValidator,
  exitPage,
}) => {
  const classes = useStyles();

  return (
    <Paper elevation={4} className={classes.root}>
      <CreateAccountSteps
        step={step}
        backRouter={backRouter}
        nextRouter={nextRouter}
        form={form}
        setForm={setForm}
        formValidator={formValidator}
        exitPage={exitPage}
      ></CreateAccountSteps>
    </Paper>
  );
};

export default CreateAccountCard;
